<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["data-id", "data-disabled", "data-active", "data-pointer-disabled"];
const _hoisted_2 = {
  key: 0,
  class: "magic-command-item__pointer-guard"
};
import {
  ref,
  computed,
  inject,
  provide,
  onBeforeUnmount,
  useId,
  onMounted
} from "vue";
import { useCommandItem } from "../composables/private/useCommandItem";
import { useCommandState } from "../composables/private/useCommandState";
import {
  MagicCommandInstanceId,
  MagicCommandViewId,
  MagicCommandContentId,
  MagicCommandItemId,
  MagicCommandItemActive,
  MagicCommandItemDisabled
} from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicCommandItem",
  props: {
    id: { type: String, required: false },
    initial: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const instanceId = inject(MagicCommandInstanceId, void 0);
    const viewId = inject(MagicCommandViewId, void 0);
    const contentId = inject(MagicCommandContentId, void 0);
    const elRef = ref(void 0);
    if (!instanceId) {
      throw new Error("MagicCommandItem must be nested inside MagicCommandProvider");
    }
    if (!viewId) {
      throw new Error("MagicCommandItem must be nested inside MagicCommandView");
    }
    if (!contentId) {
      throw new Error("MagicCommandItem must be nested inside MagicCommandContent");
    }
    const mappedId = computed(() => __props.id ?? `magic-command-item-${useId()}`);
    const { initializeItem, deleteItem, selectItem } = useCommandItem({
      instanceId,
      viewId
    });
    const { initializeState } = useCommandState(instanceId);
    const state = initializeState();
    const item = initializeItem({
      id: mappedId.value,
      disabled: __props.disabled ?? false
    });
    const pointerDisabled = computed(() => state.input.type !== "pointer");
    const mappedDisabled = computed(() => __props.disabled ?? item?.disabled);
    const mappedActive = computed(() => item?.active);
    function guardedSelect() {
      if (state.input.type === "pointer" && !item.disabled && !item.active) {
        selectItem(mappedId.value);
      }
    }
    function onClick(event) {
      emit("click", event);
      guardedSelect();
    }
    provide(MagicCommandItemId, mappedId.value);
    provide(MagicCommandItemActive, mappedActive);
    provide(MagicCommandItemDisabled, mappedDisabled);
    onMounted(() => {
      if (__props.initial) {
        selectItem(mappedId.value);
      }
    });
    onBeforeUnmount(() => {
      deleteItem(mappedId.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "elRef",
        ref: elRef,
        class: "magic-command-item",
        "data-id": mappedId.value,
        "data-disabled": _ctx.disabled,
        "data-active": _unref(item).active,
        "data-pointer-disabled": pointerDisabled.value,
        onMouseenter: guardedSelect,
        onMousemove: guardedSelect,
        onTouchstartPassive: guardedSelect,
        onClick
      }, [
        _renderSlot(_ctx.$slots, "default", {
          itemActive: _unref(item).active,
          itemDisabled: _ctx.disabled
        }),
        pointerDisabled.value ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("v-if", true)
      ], 40, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-command-item {
  position: relative;
  cursor: var(--magic-command-item-cursor, default);
}

.magic-command-item__pointer-guard {
  position: absolute;
  inset: 0;
}
</style>
